
import { Options, Vue } from "vue-class-component";
@Options({
  name: "SvgIcon",
  props: {
    iconname: {
      type: String,
      required: true,
    }, 
  },
})
export default class SvgIcon extends Vue {
}
